import { PoiCGType } from '@/types/graphql/root';
import { useQueryClient } from '@tanstack/react-query';

export default function useToggleSavedQueryCache() {
  const queryClient = useQueryClient();

  const toggleSaved = (poi: PoiCGType) => {
    queryClient.setQueryData(['getAllSavedPois'], (oldData: PoiCGType[] | null | undefined) => {
      if (!oldData) return null;

      const hasPoi = oldData.find((savedPoi) => savedPoi.id === poi.id);
      if (hasPoi) {
        return oldData.filter((savedPoi) => savedPoi.id !== poi.id);
      } else {
        return [...oldData, poi];
      }
    });
  };

  return { toggleSaved };
}
